export default __webpack_public_path__ + "static/media/coconut.d57a636a.jpg";